import { AppInventoryOption } from '@openx/types/targeting/appInventory.ts';
import { useTranslation } from 'react-i18next';
import { useAppInventoryAllowed } from '../../shared/InventoryAndContent/featureFlags.ts';

type UseContentOptionsProps = {
  isBulk?: boolean;
};

export const useContentOptions = ({ isBulk = false }: UseContentOptionsProps) => {
  const { t } = useTranslation();
  const isAppInventoryEnabled = useAppInventoryAllowed();

  let labels: Record<string, string> = {
    [AppInventoryOption.APP_BUNDLE_ID]: t('App Bundle ID'),
  };

  const bulkOptions: Record<string, string> = {
    [AppInventoryOption.APP_BUNDLE_ID]: t('App Bundle ID'),
  };

  // When App Inventory is enabled (OA UI only):
  // - Hide APP_BUNDLE_ID from Type dropdown (App Inventory replaces it)
  // - Add APP_GROUP option at the beginning to match App Bundle ID's previous position
  // Note: Bulk Add for App Inventory is handled within AppInventoryTopBoxRenderer
  if (isAppInventoryEnabled) {
    delete labels[AppInventoryOption.APP_BUNDLE_ID];
    delete bulkOptions[AppInventoryOption.APP_BUNDLE_ID];
    labels = {
      [AppInventoryOption.APP_GROUP]: t('App Inventory'),
    };
  }

  const getOptionLabel = (option: string) => labels[option];

  const options = isBulk ? Object.keys(bulkOptions) : Object.keys(labels);

  return {
    labels,
    bulkOptions,
    getOptionLabel,
    options,
  };
};
